<nz-drawer [nzBodyStyle]="{ overflow: 'auto', 'scrollbar-gutter': 'stable' }" [nzMaskClosable]="false" [nzWidth]="850"
    [nzVisible]="isVisiblePermissionDrawer" [nzTitle]="TitleRef" [nzFooter]="footerTpl"
    (nzOnClose)="cancelPermissionDrawer()">
    <ng-container *nzDrawerContent>
        <ng-container *ngIf="!this.selectedRoleData.isBrooklynActive && this.currentSelectedTab != RoleType['Supplier']">
            <nz-table [nzTemplateMode]="true" class="permission-details-table">
                <thead>
                    <tr class="th-bg-color">
                        <th>Module Name</th>
                        <th nzAlign="center" class="center">All</th>
                        <th nzAlign="center" class="center">View</th>
                        <th nzAlign="center" class="center">Add</th>
                        <th nzAlign="center" class="center">Edit</th>
                        <th nzAlign="center" class="center">Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let permission of permissionsByRole; let i = index">
                        <ng-container
                            *ngTemplateOutlet="permissionSection; context: {
                              $implicit: permission,
                              sectionIndex: i,
                              moduleType: permission.moduleType || 'Paybev',
                              toggleHandler: paybevOnlyToggle,
                              allHandler: paybevOnlyAll
                            }"></ng-container>
                    </ng-container>
                </tbody>
            </nz-table>
        </ng-container>

        <ng-container *ngIf="this.selectedRoleData.isBrooklynActive || currentSelectedTab == RoleType['Supplier']">
            <nz-tabset [nzSelectedIndex]="currentSelectPermissionsTab" (nzSelectedIndexChange)="onTabChange($event)">

                <nz-tab nzTitle="Brooklyn Permissions"
                    *ngIf="this.selectedRoleData.isBrooklynActive || (this.selectedRoleData.isBrooklynActive && this.currentSelectedTab == 2)">
                    <nz-table [nzTemplateMode]="true" class="permission-details-table">
                        <thead>
                            <tr class="th-bg-color">
                                <th>Module Name</th>
                                <th nzAlign="center" class="center">All</th>
                                <th nzAlign="center" class="center">View</th>
                                <th nzAlign="center" class="center">Add</th>
                                <th nzAlign="center" class="center">Edit</th>
                                <th nzAlign="center" class="center">Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let permission of brooklynRolePermissions; let i = index">
                                <ng-container
                                    *ngTemplateOutlet="permissionSection; context: {
                                      $implicit: permission,
                                      sectionIndex: i,
                                      moduleType: permission.moduleType || 'Brooklyn',
                                      toggleHandler: brooklynToggle,
                                      allHandler: brooklynAll
                                    }"></ng-container>
                            </ng-container>
                        </tbody>
                    </nz-table>
                </nz-tab>

                <nz-tab nzTitle="Supplier Permissions" *ngIf="currentSelectedTab == RoleType['Supplier']">
                    <nz-table [nzTemplateMode]="true" class="permission-details-table">
                        <thead>
                            <tr class="th-bg-color">
                                <th>Module Name</th>
                                <th nzAlign="center" class="center">All</th>
                                <th nzAlign="center" class="center">View</th>
                                <th nzAlign="center" class="center">Add</th>
                                <th nzAlign="center" class="center">Edit</th>
                                <th nzAlign="center" class="center">Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let permission of supplierRolesPermissions; let i = index">
                                <ng-container
                                    *ngTemplateOutlet="permissionSection; context: {
                                      $implicit: permission,
                                      sectionIndex: i,
                                      moduleType: permission.moduleType || 'Supplier',
                                      toggleHandler: supplierToggle,
                                      allHandler: supplierAll
                                    }"></ng-container>
                            </ng-container>
                        </tbody>
                    </nz-table>
                </nz-tab>

                <nz-tab [nzTitle]="currentSelectedTab == RoleType['Internal'] ? 'Paybev Permissions' : 'Supplier Bank Permissions'">
                    <nz-table [nzTemplateMode]="true" class="permission-details-table">
                        <thead>
                            <tr class="th-bg-color">
                                <th>Module Name</th>
                                <th nzAlign="center" class="center">All</th>
                                <th nzAlign="center" class="center">View</th>
                                <th nzAlign="center" class="center">Add</th>
                                <th nzAlign="center" class="center">Edit</th>
                                <th nzAlign="center" class="center">Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let permission of paybevRolePermissions; let i = index">
                                <ng-container
                                    *ngTemplateOutlet="permissionSection; context: {
                                      $implicit: permission,
                                      sectionIndex: i,
                                      moduleType: permission.moduleType || 'Paybev',
                                      toggleHandler: paybevToggle,
                                      allHandler: paybevAll
                                    }"></ng-container>
                            </ng-container>
                        </tbody>
                    </nz-table>
                </nz-tab>
            </nz-tabset>
        </ng-container>
    </ng-container>

    <ng-template #permissionSection let-permission let-sectionIndex="sectionIndex" let-moduleType="moduleType"
        let-toggleHandler="toggleHandler" let-allHandler="allHandler">
        <tr *ngIf="permission.header" class="permission-header-row"
            [class.permission-header-clickable]="permission._uiCollapsible"
            (click)="permission._uiCollapsible && (permission._uiExpanded = !permission._uiExpanded)">
            <td colspan="6" class="permission-header-cell">
                <i nz-icon [nzType]="permission._uiExpanded ? 'down' : 'right'" nzTheme="outline"
                    class="permission-header-caret"
                    [class.permission-caret-hidden]="!permission._uiCollapsible"></i>
                <span class="permission-section-title">{{ permission._uiHeaderLabel }}</span>
            </td>
        </tr>
        <ng-container *ngIf="!permission._uiCollapsible || permission._uiExpanded">
            <ng-container
                *ngTemplateOutlet="permissionRows; context: {
                  $implicit: permission,
                  sectionIndex: sectionIndex,
                  moduleType: moduleType,
                  toggleHandler: toggleHandler,
                  allHandler: allHandler
                }"></ng-container>
        </ng-container>
    </ng-template>

    <ng-template #permissionRows let-permission let-sectionIndex="sectionIndex" let-moduleType="moduleType"
        let-toggleHandler="toggleHandler" let-allHandler="allHandler">
        <tr *ngFor="let childpermission of permission.permissions; let ind = index" class="border-top">
            <td [class.permission-module-parent]="!permission._uiNested"
                [class.permission-module-child]="permission._uiNested">
                {{ childpermission.module | moduleDisplayName }}
            </td>
            <td nzAlign="center">
                <span class="table-checkbox">
                    <label *ngIf="childpermission._uiShowAll"
                        (ngModelChange)="allHandler(sectionIndex, ind, !childpermission.hasAll, moduleType)" nz-checkbox
                        [nzDisabled]="!!childpermission._uiDisabled" [(ngModel)]="childpermission.hasAll"></label>
                </span>
            </td>
            <td nzAlign="center">
                <span class="table-checkbox">
                    <label nz-checkbox *ngIf="childpermission._uiShowView" [nzDisabled]="!!childpermission._uiDisabled"
                        [(ngModel)]="childpermission.canView"
                        (ngModelChange)="toggleHandler(sectionIndex, ind, childpermission.canView, 'view', moduleType)"></label>
                </span>
            </td>
            <td nzAlign="center">
                <span class="table-checkbox">
                    <label nz-checkbox *ngIf="childpermission._uiShowAdd" [nzDisabled]="!!childpermission._uiDisabled"
                        [(ngModel)]="childpermission.canAdd"
                        (ngModelChange)="toggleHandler(sectionIndex, ind, childpermission.canAdd, 'add', moduleType)"></label>
                </span>
            </td>
            <td nzAlign="center">
                <span class="table-checkbox">
                    <label nz-checkbox *ngIf="childpermission._uiShowEdit" [nzDisabled]="!!childpermission._uiDisabled"
                        [(ngModel)]="childpermission.canEdit"
                        (ngModelChange)="toggleHandler(sectionIndex, ind, childpermission.canEdit, 'edit', moduleType)"></label>
                </span>
            </td>
            <td nzAlign="center">
                <span class="table-checkbox">
                    <label nz-checkbox *ngIf="childpermission._uiShowDelete"
                        [nzDisabled]="!!childpermission._uiDisabled" [(ngModel)]="childpermission.canDelete"
                        (ngModelChange)="toggleHandler(sectionIndex, ind, childpermission.canDelete, 'delete', moduleType)"></label>
                </span>
            </td>
        </tr>
    </ng-template>

    <ng-template #TitleRef>
        <span>{{ selectedRoleData.name }}</span>
    </ng-template>
    <ng-template #footerTpl>
        <div class="d-flex justify-content-end">
            <button *ngIf="canEditRole" nz-button nzType="primary" (click)="handleOkPermissionDrawer()"
                [nzLoading]="isLoadingOne" class="medium-btn small-btn width-100 mr-1">Update</button>
            <button nz-button nzType="default" (click)="cancelPermissionDrawer()"
                class="dlt-btn width-100">Cancel</button>
        </div>
    </ng-template>
</nz-drawer>
